import { render, staticRenderFns } from "./UpdateManual.vue?vue&type=template&id=4f7c71b6"
import script from "./UpdateManual.vue?vue&type=script&lang=js"
export * from "./UpdateManual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports